import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import PcHome from './home-pc.vue'
import H5Home from './home-h5.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (!_ctx.$isMobile)
    ? (_openBlock(), _createBlock(PcHome, { key: 0 }))
    : (_openBlock(), _createBlock(H5Home, { key: 1 }))
}
}

})